<template>
  <ValidationObserver ref="userLoginForm">
    <b-form class="form" @submit.stop.prevent="onSubmit">
      <div class="container">
        <div class="row justify-content-center">
          <div class="form-wraapper-inner">
            <h2>Willkommen zurück!</h2>
            <p>Bitte füllen Sie die Formularfelder aus um sich anzumelden.</p>

            <div v-if="errors.length">
              <div
                role="alert"
                v-bind:class="{ show: errors.length }"
                class="alert fade alert-danger"
              >
                <div class="alert-text" v-if="errors">{{ errors }}</div>
              </div>
            </div>

            <ValidationProvider
              name="email"
              rules="required|email"
              v-slot="{ errors }"
              :custom-messages="{
                required: 'Email is required.',
              }"
            >
              <v-text-field
                autocomplete="new-password"
                v-model="form.email"
                :error-messages="errors[0]"
                label="E-Mail"
                outlined
              ></v-text-field>
            </ValidationProvider>

            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :custom-messages="{
                required: 'Password is required.',
              }"
            >
              <div class="password-input-div">
                <v-text-field
                  :type="show === true ? 'text' : 'password'"
                  autocomplete="new-password"
                  v-model="form.password"
                  :error-messages="errors[0]"
                  label="Passwort"
                  outlined
                ></v-text-field>
                <i
                  class="fas fa-eye show-icon"
                  v-if="show"
                  @click="show = !show"
                ></i>
                <i
                  class="fas fa-eye-slash show-icon"
                  v-else
                  @click="show = !show"
                ></i>
              </div>
            </ValidationProvider>
            <v-btn
              type="submit"
              ref="kt_form_submit_btn"
              class="submit-btn-fill-color mt-3"
              :disabled="isDisabled"
            >
              {{ loginText }}
            </v-btn>
            <!-- <button type="submit" :disabled="isDisabled" class="registerbtn">
                {{ loginText }}
              </button> -->
            <!-- <GoogleLogin
                :params="params"
                :onSuccess="onSuccess"
                :onFailure="onFailure"
                >Login</GoogleLogin
              > -->
            <div class="signin">
              <p>
                <router-link to="/passwort-vergessen"
                  rel="noindex,nofollow">Passwort vergessen?</router-link
                >
              </p>
              <p>
                Haben Sie noch keinen Account?
                <!-- <router-link to="/register"
                  >Registrieren Sie sich bitte.</router-link
                > -->
                <a href="https://marktplatzgenius.lcmx.at/register?type=dealer">Registrieren Sie sich bitte.</a>
              </p>
            </div>
          </div>
          <div class="col-md-12 go-to-home-page mt-8 text-center">
            <a href="https://marktplatzgenius.lcmx.at">
              <v-btn depressed class="outline-button"
                ><b-icon icon="arrow-left" class="mr-3"></b-icon>Zurück zur
                Startseite</v-btn
              >
            </a>
          </div>
        </div>
      </div>
    </b-form>
  </ValidationObserver>
</template>

<script>
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import { LOGIN } from "@/core/services/store/auth.module";
import GoogleLogin from "vue-google-login";

export default {
  name: "Login",
  components: {
    // GoogleLogin
  },
  data() {
    return {
      loginText: "Anmeldung",
      btnDisable: false,
      show: false,
      params: {
        client_id:
          "203598066871-u72palmfj4cnj62bpmu236qg084pj6fm.apps.googleusercontent.com",
      },
      form: {
        email: "",
        password: "",
      },
    };
  },
  beforeCreate() {
    
    if (this.isAuthenticated && this.currentUser && this.currentUser.role === 'producer') {
      
      this.$router.push({
        name: "producer-dashboard",
      });
    } 
    if(this.isAuthenticated && this.currentUser && this.currentUser.role === 'admin'){
      
      this.$router.push({
        name: "admin-dashboard",
      });
    }
  },
  mounted() {
   
  },
  methods: {
    onSuccess(googleUser) {
    },
    onFailure(err) {
      console.log(err);
    },
    onSubmit() {
      this.$refs.userLoginForm.validate().then((success) => {
        if (success) {
          this.btnDisable = true;
          this.loginText = "Anmeldung läuft...";
          let data = {
            email: this.form.email,
            password: this.form.password,
          };
          setTimeout(() => {
            this.$store
              .dispatch(LOGIN, data)
              .then((response) => {
                if (response.login_status === "success") {
                  localStorage.removeItem("userCheckoutDetails");
                  if (
                    this.$route.query.redirect &&
                    this.$route.query.redirect === "checkout"
                  ) {
                    this.$router.push({
                      path: "/checkout",
                    });
                  } else {
                    switch (response.role) {
                      case "admin":
                        if (this.$route.query.redirect) {
                          this.$router.push({
                            path:
                              "/admin/support-response/" + this.$route.query.to,
                          });
                        } else {
                          this.$router.push({
                            name: "admin-dashboard",
                          });
                        }
                        break;

                      case "producer":
                        this.$router.push({
                          name: "producer-dashboard",
                        });
                        break;

                      default:
                        this.$router.push({
                          name: "index",
                        });
                    }
                  }
                } else {
                  this.btnDisable = false;
                  this.loginText = "Anmeldung";
                }
              })
              .catch((err) => {
                this.btnDisable = false;
                this.loginText = "Anmeldung";
              });
          }, 2000);
        }
      });
    },
  },
  computed: {
    ...mapGetters(["isAuthenticated", "currentUser"]),
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
    isDisabled: function () {
      return this.btnDisable;
    },
  },
};
</script>

<style scoped>
.password-input-div {
  position: relative;
}
.show-icon {
  position: absolute;
  top: 22px;
  right: 20px;
  cursor: pointer;
}
</style>